import { useMemo } from 'react'

import type { Hit } from '@segment/api/algolia/client'

import type { Resource } from '@segment/api/types/resource'

import { useResourcesQuery } from '@segment/api/routes/resources/queries'

interface useResourcesGridProps {
  query: string
  filters: string
}

const useResourcesGrid = ({ query = ``, filters = `` }: useResourcesGridProps) => {
  const { data, hasNextPage, isLoading, fetchNextPage } = useResourcesQuery({
    args: [{ filters, query }],
    options: { keepPreviousData: true },
  })

  const flattenedPages: Hit<Omit<Resource, `featured`>>[] | undefined = useMemo(
    () => data?.pages.flatMap(({ hits }) => hits),
    [data?.pages]
  )

  return {
    hasNextPage,
    isLoading,
    isEmpty: !isLoading && !hasNextPage && flattenedPages && flattenedPages?.length === 0,
    fetchNextPage,
    flattenedPages,
  }
}

export default useResourcesGrid
